
















import { Vue, Component } from 'vue-property-decorator';
import appConfig from '../../appConfig';

@Component
export default class About1dService extends Vue {
    private goOssLicensePage() {
        this.$router.push('/OpenSourceLicense');
    }
}
